module.exports = __webpack_public_path__ + "static/media/refresh.83137947.svg";